export default __webpack_public_path__ + "static/media/whatsapp.18a65edc.svg";